import type { FormFields } from './Newsletter.types';

export const performSubscribeNewster = async ({
  email,
  firstName,
  lastName,
  cfTurnstileResponse,
}: FormFields) =>
  fetch('/d/mvc/subscribetonewsletter/subscribe', {
    body: JSON.stringify({ email, firstName, lastName }),
    headers: {
      'Content-Type': 'application/json',
      'X-Turnstile-Token': cfTurnstileResponse,
    },
    method: 'POST',
  });
